<template>
  <div id="bottom-cta">
    <img
      id="img-on-top"
      :src="require('@/assets/sloth-w-coffee.svg')"
      alt="Week planner preview"
    />
    <div id="text-wrapper">
      <h2>{{ $t(header) }}</h2>
      <!-- <p>Say goodbye to spreadsheets and hello to simplified team availability.</p> -->
      <p>{{ $t(description) }}</p>
      <getCTA
        :btn-text="button"
      />
      <p class="caption">{{ $t("noCreditCardRequiredCTA") }}</p>
    </div>
  </div>
</template>

<script>
import getCTA from "@/components/getCTA.vue";

export default {
  name: "BottomCTA",
  components: {
    getCTA,
  },
  props: {
    header: {
      type: String,
      default: "stayOnTopOfSchedule"
    },
    description: {
      type: String,
      default: "tryTheUltimateSolution"
    },
    button: {
      type: String, 
      default: "startFreeTrial"
    }
  }
};
</script>

<style lang="scss" scoped>
#bottom-cta {
  text-align: center;
  max-width: $maxWidth;
  margin: 0 auto;

  #img-on-top {
    transform: translateY(33%);
    @include respond-below(xs) {
      transform: translateY(28%);
    }
  }
  #text-wrapper {
    background-color: $grayL;
    margin: 20px calc(var(--gutter) * -1);
    padding: 54px var(--gutter);
    text-align: center;

    @include respond-above(md) {
      border-radius: 13px;
      padding: 60px 120px;
    }

    h2 {
      // margin-top: 6px;
      margin-bottom: 20px;
      @include respond-above(sm) {
        margin-top: 20px;
        padding: 0 20px;
      }
    }

    p {
      margin-bottom: 48px;
    }
    p.caption {
      margin: 12px 0 0;
    }
  }
}
</style>
